import React from 'react'
import { bool, func, node, string } from 'prop-types'
import { InputSearchElement, InputLabel, Input } from './InputSearch.style'
import { InputHelperText } from './InputHelperText'
import { useInputSearch } from './useInputSearch'
import { InputButtonSearch } from './InputButtonSearch'
import { IconSearch, IconLoading, IconErase } from './Icons'

const propTypes = {
  type: string,
  autoFocus: bool,
  autoComplete: string,
  loading: bool,
  disabled: bool,
  component: node,
  error: bool,
  helperText: node,
  name: string,
  label: string,
  id: string,
  value: string,
  placeholder: string,
  className: string,
  onChange: func,
  onFocus: func,
  onBlur: func,
  onSearch: func,
}

const InputSearch = React.forwardRef(
  (
    {
      type = 'text',
      autoFocus = false,
      autoComplete = 'off',
      loading = false,
      disabled = false,
      component,
      error,
      helperText,
      label,
      name,
      id,
      value,
      placeholder,
      className,
      onChange,
      onFocus,
      onBlur,
      onSearch,
      ...props
    },
    ref,
  ) => {
    const {
      active,
      focused,
      text,
      erease,
      setRef,
      handleOnBlur,
      handleOnFocus,
      handleOnClick,
      handleOnChange,
      handleOnSearch,
      handleOnKeyDown,
      handleOnErase,
    } = useInputSearch({
      ref,
      value,
      disabled,
      placeholder,
      onChange,
      onBlur,
      onFocus,
      autoFocus,
      onSearch,
    })

    return (
      <>
        <InputSearchElement
          onClick={handleOnClick}
          focused={focused}
          {...props}
        >
          <InputLabel
            htmlFor={id}
            active={active}
            disabled={disabled}
            error={Boolean(error)}
          >
            {label}
          </InputLabel>
          <Input
            type={type}
            component={component}
            ref={setRef}
            autoFocus={autoFocus}
            autoComplete={autoComplete}
            disabled={disabled}
            name={name}
            id={id}
            value={text}
            placeholder={placeholder}
            className={className}
            onChange={handleOnChange}
            onFocus={handleOnFocus}
            onBlur={handleOnBlur}
            onKeyDown={handleOnKeyDown}
          />
          {!loading && !erease && (
            <InputButtonSearch
              data-testid="searchableButton"
              onClick={handleOnSearch}
            >
              <IconSearch disabled={disabled} />
            </InputButtonSearch>
          )}
          {!loading && erease && (
            <InputButtonSearch
              data-testid="cleanableButton"
              onClick={handleOnErase}
            >
              <IconErase disabled={disabled} />
            </InputButtonSearch>
          )}
          {loading && (
            <InputButtonSearch data-testid="loadingButton">
              <IconLoading />
            </InputButtonSearch>
          )}
        </InputSearchElement>
        {helperText && !error && (
          <InputHelperText>{helperText}</InputHelperText>
        )}
        {error && !disabled && <InputHelperText error>{error}</InputHelperText>}
      </>
    )
  },
)

InputSearch.propTypes = propTypes

export { InputSearch }
